import { ModalDialog } from 'core-components/library/modalDialog'
import { WidgetsListDetail } from 'core-components/sitebuilder/settings/Detail'
import { IWidgetSettings } from 'core-components/sitebuilder/settings/models/IWidgetSettings'

export const WidgetSettings = ({
  pageWidget,
  widget,
  widgetsData,
  isUserSettings,
  onClose,
  onChangeAndClose,
  additionalSettings,
  hasAdditionalSettings,
  renderCustomSettingsWidget,
}: IWidgetSettings) => {
  return (
    <ModalDialog
      show
      onClose={onClose}
      size={'md'}
      content={() => (
        <WidgetsListDetail
          renderCustomSettingsWidget={renderCustomSettingsWidget}
          widget={widget}
          pageWidget={pageWidget}
          widgetsData={widgetsData}
          isUserSettings={isUserSettings}
          onClose={onClose}
          onChangeAndClose={(pageWidgetSettings, additionalSettings, redactorSettings) =>
            onChangeAndClose(pageWidgetSettings, additionalSettings, redactorSettings)
          }
          hasAdditionalSettings={hasAdditionalSettings}
          additionalSettings={additionalSettings}
        />
      )}
    />
  )
}
